import PropTypes from 'prop-types';
import classNames from 'classnames';
import MapLegendClassItem from './MapLegendClassItem';
import MapLegendClassesBar from './MapLegendClassesBar';
import './style.scss';

const roundValue = value => {
	try {
		const valueFloat = Number.parseFloat(value);

		return Math.round(valueFloat * 1000) / 1000;
	} catch (error) {
		return value;
	}
};

const MapLegendAttributeClasses = ({intervals, image, expanded, unit}) => {
	const classes = classNames('ptr-MapLegendClasses', {
		'is-expanded': expanded,
	});

	const intervalsKey = intervals.map(i => i.interval.toString()).join(',');
	return (
		<div className={classes}>
			{expanded ? (
				intervals.map(interval => (
					<MapLegendClassItem
						key={`${intervalsKey}_${interval.interval}`}
						color={interval.fill}
						label={
							interval?.name ||
							`${roundValue(interval?.interval[0])} - ${roundValue(
								interval?.interval[1],
							)}`
						}
						unit={unit}
					/>
				))
			) : (
				<MapLegendClassesBar intervals={intervals} unit={unit} image={image} />
			)}
		</div>
	);
};

MapLegendAttributeClasses.propTypes = {
	intervals: PropTypes.array,
	expanded: PropTypes.bool,
	unit: PropTypes.string,
	image: PropTypes.string,
};

export default MapLegendAttributeClasses;
